import { render, staticRenderFns } from "./UcTemplate.yaml?vue&type=template&id=66511818&component"
import script from "./UcTemplate.yaml?vue&type=script&lang=ts&component"
export * from "./UcTemplate.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports